'use strict';

export function authInterceptor($rootScope, $q, $cookies, $injector, Util, Config) {
  'ngInject';

  var state;
  return {
    // Add authorization token to headers
    request(config) {
      config.headers = config.headers || {};
      if($cookies.get('token') && Util.isSameOrigin(config.url)) {
        config.headers.Authorization = `Bearer ${$cookies.get('token')}`;
      }
      return config;
    },

    // Intercept 401s and redirect you to login
    responseError(response) {
      const passwordOnlyLogin = Config.getModuleConfig(Config.Modules.SignUp).getPasswordOnlyLogin();

      if(response.status === 401) {

        let oState = (state || (state = $injector.get('$state')));

        if (passwordOnlyLogin) {
          oState.go('protected');
        } else {
          oState.go('login');
        }

        // remove any stale tokens
        $cookies.remove('token');
      }
      return $q.reject(response);
    }
  };
}



// WEBPACK FOOTER //
// ./client/~ap/auth/interceptor.service.js